export default __webpack_public_path__ + "static/media/header_logo.4a9589db.png";